/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { useState, useEffect } from 'react';
import { ArrowLeft } from 'phosphor-react';

import globalStyles from "globalStyles";
const { button } = globalStyles.components;

import { useCreateSupportIssue } from '@fitinsur/services/SupportService';

import { supportTypes } from '..';
import { CloseButton } from '../../CloseButton';
import { ScreenshotButton } from '../ScreenshotButton';
import { Loading } from '../../Loading';

export const SupportContentStep = ({
  supportType,
  onSupportRestartRequested,
  onSupportSent,
}) => {
  const [screenshot, setScreenshot] = useState(null);
  const [comment, setComment] = useState('');
  const [isSendingSupport, setIsSendingSupport] = useState(false);

  const supportTypeInfo = supportTypes[supportType];

  const {
    loading: useCreateSupportIssueLoading,
    request: useCreateSupportIssueRequest,
  } = useCreateSupportIssue();

  async function handleSubmitSupport(event) {
    event.preventDefault();

    if (isSendingSupport) {
      return;
    }

    try {
      useCreateSupportIssueRequest({
        supportType,
        screenshot,
        comment,
      })
        .then((resp) => {
          const { data: { value } } = resp;
          onSupportSent(value);
        });

    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    setIsSendingSupport(useCreateSupportIssueLoading)
  }, [useCreateSupportIssueLoading]);

  return (
    <>
      <header style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
      }}>
        <button
          type="button"
          style={{
            color: "#353535",
            backgroundColor: 'transparent',
            border: "none",
            cursor: "pointer",
          }}
          onClick={onSupportRestartRequested}
        >
          <ArrowLeft weight="bold" size={16} />
        </button>

        <div
          style={{
            display: 'flex',
            gap: "4px",
            alignItems: "center",
          }}
        >
          <img
            src={supportTypeInfo.image.source}
            alt={supportTypeInfo.image.alt}
            style={{
              width: '20px',
            }}
          />
          <span style={{
            color: "#898887",
            padding: 0,
          }}>
            {supportTypeInfo.title}
          </span>
        </div>

        <CloseButton />
      </header>

      <form
        style={{
          width: '100%',
          margin: '16px 0',
        }}
        onSubmit={handleSubmitSupport}
      >
        <textarea
          style={{
            width: '100%',
            minHeight: '112px',
            fontSize: '14px',
            color: '#898887',
            border: '2px solid rgba(0, 0, 0, 0.1)',
            padding: '8px',
            backgroundColor: '#F3F4F6',
            borderRadius: '4px',
            resize: 'none',
          }}
          placeholder="Conte com detalhes o que está acontecendo"
          onChange={(event) => setComment(event.target.value)}
        />
        <footer
          style={{
            display: 'flex',
            gap: '8px',
            marginTop: '8px',
          }}
        >
          <ScreenshotButton
            screenshot={screenshot}
            onScreenShotTook={setScreenshot}
          />

          <button
            type="submit"
            disabled={comment.length === 0 || isSendingSupport}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flex: '1',
              padding: '4px',
              backgroundColor: button.secondaryMixin.secondary,
              color: button.secondaryMixin.primary,
              fontWeight: 'bold',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            <>
              {isSendingSupport && <Loading />}
              Criar chamado de suporte
            </>
          </button>
        </footer>
      </form>
    </>
  );
};
